import { useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useGuestContext } from "../../../contexts/GuestContext";
import { getEventPin, handlePinAuthError } from "../../../utils/pinAuth";

function CheckInConfirmation({ details }) {
  const { language } = useGuestContext();

  useEffect(() => {
    const isEnglish = language === "English";
    const htmlContent = `
      <div style="overflow-x:auto">
        <table style="width:100%;border-collapse:collapse">
          <tbody>
            <tr><th style="text-align:left;padding:8px">Guest ID</th><td>${details.guestId}</td></tr>
            <tr><th style="text-align:left;padding:8px">${isEnglish ? "Name" : "姓名"}</th><td>${details.firstname} ${details.lastname}</td></tr>
            <tr><th style="text-align:left;padding:8px">${isEnglish ? "Chinese name" : "中文姓名"}</th><td>${details.chinesename || (isEnglish ? "Not provided" : "未填寫")}</td></tr>
            <tr><th style="text-align:left;padding:8px">${isEnglish ? "Phone" : "電話"}</th><td>${details.phone || ""}</td></tr>
            <tr><th style="text-align:left;padding:8px">${isEnglish ? "Email" : "電子郵件"}</th><td>${details.email || (isEnglish ? "Not provided" : "未填寫")}</td></tr>
          </tbody>
        </table>
      </div>
      ${details.registeredForSession === false ? `
        <p style="margin-top:12px;padding:10px;border-radius:6px;background:#fff4db;border:1px solid #f0a43b;color:#7a4c00">
          ${isEnglish
            ? `This guest did not sign up for ${details.session || "this session"}. Checking in will add them to it.`
            : `此居士未報名${details.session || "本場次"}，完成報到將自動為其加入。`}
        </p>` : ""}`;

    Swal.fire({
      title: isEnglish ? "Confirm check-in" : "報到確認",
      html: htmlContent,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: isEnglish ? "Check in" : "完成報到",
      cancelButtonText: isEnglish ? "Cancel" : "取消",
      allowOutsideClick: false,
    }).then(async (result) => {
      if (!result.isConfirmed) {
        window.location.href = "/checkinSearch";
        return;
      }

      try {
        const pin = await getEventPin();
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/event/checkinconfirm?guestid=${details.guestId}`,
          { headers: { 'X-Event-Pin': pin } }
        );
        if (response.data?.status !== "success") throw new Error("Check-in failed");
        const added = response.data?.autoRegistered
          ? (isEnglish
              ? ` They were also added to ${response.data.session || "this session"}.`
              : `，並已為其補登記${response.data.session || "本場次"}。`)
          : "";
        await Swal.fire({
          title: isEnglish ? "Check-in successful" : "報到成功",
          text: isEnglish
            ? `Guest ID ${details.guestId} has been checked in.${added}`
            : `Guest ID ${details.guestId} 已完成報到${added || "。"}`,
          icon: "success",
          confirmButtonText: "OK",
        });
        window.location.href = "/checkinSearch";
      } catch (error) {
        if (error.response?.status === 401) {
          handlePinAuthError();
          return;
        }
        await Swal.fire({
          title: isEnglish ? "Check-in failed" : "報到失敗",
          text: error.response?.data?.detail || (isEnglish ? "Please ask a volunteer for help." : "請洽現場義工協助。"),
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    });
  }, [details, language]);

  return null;
}

export default CheckInConfirmation;
